import CardPost from './card-post';

export default CardPost;